const RealtorCRMIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5 17H17.9C18.4601 17 18.7401 17 18.954 16.891C19.1422 16.7951 19.2951 16.6422 19.391 16.454C19.5 16.2401 19.5 15.9601 19.5 15.4V3M9.5 13L6.1 13C5.53995 13 5.25992 13 5.04601 12.891C4.85785 12.7951 4.70487 12.6422 4.609 12.454C4.5 12.2401 4.5 11.9601 4.5 11.4V3M22 3L2 3M9.5 3L9.5 19.4C9.5 19.9601 9.5 20.2401 9.609 20.454C9.70487 20.6422 9.85785 20.7951 10.046 20.891C10.2599 21 10.5399 21 11.1 21H12.9C13.4601 21 13.7401 21 13.954 20.891C14.1422 20.7951 14.2951 20.6422 14.391 20.454C14.5 20.2401 14.5 19.9601 14.5 19.4L14.5 3L9.5 3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RealtorCRMIcon;
